import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import {withStyles} from 'material-ui/styles/index'
import Container from '../../../common/components/Container'
import Typography from 'material-ui/Typography'
import {contact as text} from '../text'
import Grid from '../../../common/components/Grid'
import TextField from 'material-ui/TextField'
import {Button, LoadingIndicator} from '../../../components'
import Dialog, {DialogTitle, DialogContent, DialogContentText, DialogActions} from 'material-ui/Dialog'

const
  styles = theme => ({
    topBanner: {
      marginTop: 0,
      paddingTop: 45,
      paddingBottom: 40,
      background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        marginTop: -47,
      },
    },
    screenTitle: {
      color: '#FFF',
    },
    title: {
      maxWidth: 500,
      margin: '0 auto',
      color: '#FFF',
    },
    subtitle: {
      paddingBottom: 50,
      textAlign: 'center',
      whiteSpace: 'pre-line',
    },
    faqsLink: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      cursor: 'pointer',
    },
    formContainer: {
      maxWidth: 750,
      margin: 'auto',
    },
    buttonContainer: {
      textAlign: 'right',
    },
    button: {
      minWidth: 128,
    },
    error: {
      color: 'red',
    },
  })

class Contact extends React.Component {

  static displayName = 'Contact.component'

  handleFaqsLink = () => this.props.history.push('/ayuda/faqs')

  isButtonDisabled = () => {
    return this.props.name === '' || this.props.email === '' || this.props.message === ''
  }

  render() {
    const {classes, error, blockEmailField} = this.props

    const isEmailError = error === 'Email inválido'

    return (
      <div>
        <div className={classes.topBanner}>
          <Typography variant={'subheading'} className={classes.screenTitle} gutterBottom={true}>
            {text.screenTitle}
          </Typography>
          <Typography variant={'display1'} className={classes.title} gutterBottom={true}>
            {text.title}
          </Typography>
        </div>
        <Container>
          <Typography variant={'body1'} color={'textSecondary'} className={classes.subtitle}>
            {text.subtitle}
            <span className={classes.faqsLink} onClick={this.handleFaqsLink}> {text.faqsLink}</span>
          </Typography>
          <div className={classes.formContainer}>
            <Grid container>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="name"
                  label={text.nameLabel}
                  type="text"
                  fullWidth={true}
                  value={this.props.name}
                  onChange={(e) => this.props.setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="email"
                  label={text.emailLabel}
                  type="email"
                  fullWidth={true}
                  value={this.props.email}
                  onChange={(e) => this.props.setEmail(e.target.value)}
                  error={isEmailError}
                  helperText={isEmailError ? error : ''}
                  disabled={blockEmailField === true && isEmailError === false}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="message"
                  label={text.messageLabel}
                  type="text"
                  fullWidth={true}
                  multiline={true}
                  rows={8}
                  value={this.props.message}
                  onChange={(e) => this.props.setMessage(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} className={classes.buttonContainer}>
                <LoadingIndicator show={this.props.loading} style={{display: 'inline-block'}}>
                  <Button
                    variant={'primary'}
                    className={classes.button}
                    onClick={this.props.sendContactMessage}
                    disabled={this.isButtonDisabled()}
                  >
                    {text.button}
                  </Button>
                </LoadingIndicator>
              </Grid>
              {
                this.props.error !== '' && isEmailError !== true &&
                <Grid item xs={12} safariFix={true}>
                  <Typography className={classes.error}>{this.props.error}</Typography>
                </Grid>
              }
            </Grid>
          </div>
        </Container>
        <Dialog
          open={this.props.showContactSuccessMessage}
          onClose={() => this.props.setShowContactSuccessMessage(false)}
        >
          <DialogTitle>{text.sent.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {text.sent.body}
              <span className={classes.faqsLink} onClick={this.handleFaqsLink}> {text.sent.faqsLink}</span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant={'secondary'} onClick={() => this.props.setShowContactSuccessMessage(false)}>
              {text.sent.button}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }

  static propTypes = {
    loading: PropTypes.bool.isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    message: PropTypes.string,
    sendContactMessage: PropTypes.func.isRequired,
    setName: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setMessage: PropTypes.func.isRequired,
    blockEmailField: PropTypes.bool.isRequired,
    showContactSuccessMessage: PropTypes.bool.isRequired,
    setShowContactSuccessMessage: PropTypes.func.isRequired,
  }
}

export default compose(withStyles(styles, {withTheme: true}))(Contact)



// WEBPACK FOOTER //
// ./src/sections/help/components/contact.js